/*
 * utils.rule.qinput.ts
 *
 * Rules for qinput.
 */
import { date as $qDate } from 'quasar';
import type { mtAttendanceLocationDto } from 'src/eServices/attendance/dto/attendanceLocation.dto';
import type { mtUserLicenseClassDto } from 'src/user/dto/userLicenseClass.dto';
import type { mtUserStaffPositionDto } from 'src/user/dto/userStaffPosition.dto';
//
export class mcUtilsRuleQinput {
  private cvifEmailIsValid(psEmail: string): boolean {
    const lrEmailPattern =
      /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
    return lrEmailPattern.test(psEmail);
  }
  //
  private cvifIsNumber(psValue: string, pbIntegerOnly: boolean = false): boolean {
    // Number.isFinite(number)  : boolean
    // - return false:
    //   = Number.isFinite('')
    //   = Number.isFinite('100')
    //   = Number.isFinite(null)
    //   = Number.isFinite(undefined)
    //   = Number.isFinite(0 / 0)
    //   = Number.isFinite(Infinity)
    //   = Number.isFinite(=Infinity)
    //   = Number.isFinite(NaN)
    //   = Number.isFinite(true)
    //   = Number.isFinite(false)
    // Number.isInteger(number) : boolean
    // - return true
    //   = Number.isInteger(100.00); // Needs special attention
    // - return false
    //   = Number.isInteger(100.12)
    //   = Number.isInteger('100)
    // Number.parseFloat(string): floatingPointNumber | NaN (Not a Number);
    // - return NaN
    //   = Number.parseFloat('')
    //   = Number.parseFloat(null)
    //   = Number.parseFloat(undefined)
    //
    const lbIsNumber: boolean = Number.isFinite(Number.parseFloat(psValue));
    if (false === pbIntegerOnly) {
      return lbIsNumber;
    }
    if (true === pbIntegerOnly && true === lbIsNumber) {
      const lbIsInteger: boolean = Number.isInteger(Number.isFinite(Number.parseFloat(psValue)));
      return lbIsInteger;
    }
    return false;
  }
  //
  private cvifIsNumericFloat(psValue: string): boolean {
    const lrNumericFloat = /[^\d.]/g;
    return lrNumericFloat.test(psValue.trim());
  }
  // Date @ YYYY-Mmm-DD
  private cvifIsDateYYYYdMmmdDD(psDateIn: string): boolean {
    const lrDatePattern = /^d{4}-[a-zA-Z]{3}-d{2}$/;
    return lrDatePattern.test(psDateIn);
  }
  //
  public cpifRequired(psName: string) {
    // Required field.
    //
    // return (psValue: string): boolean | string => {
    //   return !!psValue || `${psName} is required!`;
    // }
    //
    function lfRequired(psValue: string): boolean | string {
      // console.log(`lfRequired()=[${JSON.stringify(psValue)}]-[${typeof psValue}]!`);
      if ('number' === typeof psValue && 0 === psValue) {
        return true;
      }
      if (null === psValue) {
        return `${psName} is required!`;
      }
      // 20240427: check for string;
      if (
        'string' === typeof psValue &&
        ('EUNDEFINED' === psValue.toUpperCase() ||
          'UNDEFINED' === psValue.toUpperCase() ||
          'UNDEFINED!' === psValue.toUpperCase())
      ) {
        return 'UNDEFINED is not allowed!';
      }
      //
      return !!psValue || `${psName} is required!`;
    }
    //
    return lfRequired;
  }
  //
  public cpifRequiredGTZero(psName: string) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function lfRequiredGTZero(pxValue: any): boolean | string {
      if (null === pxValue || undefined === pxValue) {
        return `${psName} is required!`;
      }
      if ('number' === typeof pxValue) {
        if (0 === pxValue) {
          return 'UNDEFINED is not allowed!';
        }
        return true;
      }
      return `Invalid ${psName}. Select again!`;
    }
    //
    return lfRequiredGTZero;
  }
  //
  public cpifRequiredUserRole(paValue: string[]): boolean | string {
    if (0 === paValue.length) {
      return 'User Role is required!';
    }
    if (1 < paValue.length && paValue.includes('eLCGuest')) {
      return 'Remove eLCGuest from User Role!';
    }
    if (paValue.includes('eUNDEFINED')) {
      return 'Remove eUNDEFINED from User Role!';
    }
    return true;
  }
  //
  public cpifRequiredUserRoleWeLCGuest(paValue: string[]): boolean | string {
    if (0 === paValue.length) {
      return 'User Role is required!';
    }
    // if (1 < paValue.length && paValue.includes('eLCGuest')) {
    //   return 'Remove eLCGuest from User Role!';
    // }
    if (paValue.includes('eUNDEFINED')) {
      return 'Remove eUNDEFINED from User Role!';
    }
    return true;
  }
  //
  public cpifRequiredEmail(pxValue: string): boolean | string {
    if (false === !!pxValue) {
      return 'Email is requried!';
    }
    const lrEmailPattern =
      /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
    if (false === lrEmailPattern.test(pxValue)) {
      return 'Email is invalid!';
    }
    return true;
  }
  //
  public cpifOptionalEmail(pxValue: string): boolean | string {
    if ('' === pxValue || null === pxValue) {
      return true;
    }
    const lrEmailPattern =
      /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
    if (false === lrEmailPattern.test(pxValue)) {
      return 'Email is invalid!';
    }
    return true;
  }
  //
  public cpifRequiredStaffPosition(poValue: mtUserStaffPositionDto): boolean | string {
    if (poValue.cpisPosition) {
      return true;
    }
    return 'Staff Position is required!';
  }
  //
  public cpifRequiredName(psName: string) {
    function lfRequired(psValue: string): boolean | string {
      return !!psValue || `${psName} is required!`;
    }
    return lfRequired;
  }
  //
  public cpifRequiredVOAO(psName: string) {
    function lfRequired(paValue: number[]): boolean | string {
      if (0 === paValue.length) {
        return `${psName} is required!`;
      }
      if (paValue.includes(0)) {
        return `Remove eUNDEFINED from ${psName}!`;
      }
      return true;
    }
    return lfRequired;
  }
  //
  public cpifRequiredUserLicenseClass(poValue: mtUserLicenseClassDto): boolean | string {
    if (poValue.cpisClass) {
      return true;
    }
    return 'User License Class is required!';
  }
  //
  public cpifZPNumberOnly(pxValue: string | number): boolean | string {
    // Zero or Positive number only
    if ('' !== pxValue && false === isNaN(Number(pxValue)) && 0 <= Number(pxValue)) {
      return true;
    }
    return '0 or Positive Number only!';
  }
  //
  public cpifZNNumberOnly(pxValue: string | number): boolean | string {
    // Zero or Negative number only
    if ('' !== pxValue && false === isNaN(Number(pxValue)) && 0 >= Number(pxValue)) {
      return true;
    }
    return '0 or Negative Number only!';
  }
  //
  public cpifPNumberOnly(pxValue: string | number): boolean | string {
    // Positive number only
    if ('' !== pxValue && false === isNaN(Number(pxValue)) && 0 < Number(pxValue)) {
      return true;
    }
    return 'Positive Number only!';
  }
  //
  public cpifNNumberOnly(pxValue: string | number): boolean | string {
    // Negative number only
    if ('' !== pxValue && false === isNaN(Number(pxValue)) && 0 > Number(pxValue)) {
      return true;
    }
    return 'Negative Number only!';
  }
  //
  public cpifNumberRange(pnMin: number, pnMax: number, pbMinInc: boolean = true, pbMaxInc: boolean = true) {
    // pxValue to be within range
    const lfNumberRange = (psValue: string): boolean | string => {
      //console.log(this.cvifIsNumber(psValue));
      if (false === this.cvifIsNumber(psValue)) {
        return 'Number only!';
      }
      const lnValue = Number(psValue);
      if (true === pbMinInc && true === pbMaxInc) {
        if (lnValue < pnMin) {
          return 'Must be greater or equal to ' + pnMin + '!';
        } else if (lnValue > pnMax) {
          return 'Must be smaller or equal to ' + pnMax + '!';
        }
      } else if (true === pbMinInc && false === pbMaxInc) {
        if (lnValue < pnMin) {
          return 'Must be greater or equal to ' + pnMin + '!';
        } else if (lnValue >= pnMax) {
          return 'Must be smaller than ' + pnMax + '!';
        }
      } else if (false === pbMinInc && false === pbMaxInc) {
        if (lnValue <= pnMin) {
          return 'Must be greater than ' + pnMin + '!';
        } else if (lnValue >= pnMax) {
          return 'Must be smaller than ' + pnMax + '!';
        }
      } else {
        // true === pbMinInc && false === pbMaxInc
        if (lnValue < pnMin) {
          return 'Must be greater or equal to ' + pnMin + '!';
        } else if (lnValue >= pnMax) {
          return 'Must be smaller than ' + pnMax + '!';
        }
      }
      return true;
    };
    return lfNumberRange;
  }
  //
  public cpifMinimum(pnCount: number) {
    // Minimum count of characters.
    function lfMinimum(psValue: string): boolean | string {
      return (psValue && psValue.length >= pnCount) || `Minimum ${pnCount} characters!`;
    }
    return lfMinimum;
  }
  //
  public cpifMaximum(pnCount: number) {
    // Maximum count of characters.
    function lfMaximum(psValue: string): boolean | string {
      return (psValue && psValue.length <= pnCount) || `Maximum ${pnCount} characters!`;
    }
    return lfMaximum;
  }
  //
  public cpifRequiredAttendanceLocation(poValue: mtAttendanceLocationDto): boolean | string {
    if (poValue.pisLocation) {
      return true;
    }
    return 'Attendance Location is required!';
  }
  //
  public cpifDateIsValid(
    pbAllowNull: boolean = false,
    pbAllowUndefined: boolean = false,
    pbAllowEmptyString: boolean = false,
  ) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function lfDateIsValid(pxValue: any): boolean | string {
      if (null === pxValue) {
        if (true === pbAllowNull) {
          return true;
        }
        return '<null> is not allowed!';
      }
      if (undefined === pxValue) {
        if (true === pbAllowUndefined) {
          return true;
        }
        return '<undefined> is not allowed!';
      }
      if ('' === pxValue) {
        if (true === pbAllowEmptyString) {
          return true;
        }
        return '<empty string> is not allowed!';
      }
      // YYYY-MMM-DD
      const lrDatePattern = /^\d{4}-[a-zA-Z]{3}-\d{2}$/;
      if (false === lrDatePattern.test(pxValue)) {
        return 'Invalid Date Format (YYYY-Mmm-DD)!';
      }
      //
      if ('string' === typeof pxValue || 'number' === typeof pxValue) {
        if (true === $qDate.isValid(pxValue)) {
          return true;
        }
      }
      return 'Invalid Date!';
    }
    //
    return lfDateIsValid;
  }
  //
  public cpifDateIsValidYYYYdMMdDD(
    pbAllowNull: boolean = false,
    pbAllowUndefined: boolean = false,
    pbAllowEmptyString: boolean = false,
  ) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function lfDateIsValid(pxValue: any): boolean | string {
      if (null === pxValue) {
        if (true === pbAllowNull) {
          return true;
        }
        return '<null> is not allowed!';
      }
      if (undefined === pxValue) {
        if (true === pbAllowUndefined) {
          return true;
        }
        return '<undefined> is not allowed!';
      }
      if ('' === pxValue) {
        if (true === pbAllowEmptyString) {
          return true;
        }
        return '<empty string> is not allowed!';
      }
      // YYYY-MM-DD
      const lrDatePattern = /^\d{4}-\d{2}-\d{2}$/;
      if (false === lrDatePattern.test(pxValue)) {
        return 'Invalid Date Format (YYYY-MM-DD)!';
      }
      // 20241220: '2024-02-30' => valid date! => '2024-03-01'
      // NOTE: new Date('2024-02-30') => Date Fri Mar 01 2024 08:00:00 GMT+0800 (Singapore Standard Time)
      // NOTE: $qDate uses new Date(pxValue) to check for validity!!!
      // NOTE: Hence '2024-02-30' becomes '2024-03-01' which is a VALID Date!!!
      // if ('string' === typeof pxValue || 'number' === typeof pxValue) {
      //   if (true === $qDate.isValid(pxValue)) {
      //     return true;
      //   }
      // }
      if ('string' === typeof pxValue) {
        if (false === isNaN(new Date(pxValue).getTime())) {
          const lsDateNew = new Date(pxValue).toLocaleDateString('en-CA');
          if (lsDateNew === pxValue) {
            return true;
          }
        }
      }
      //
      return 'Invalid Date!';
    }
    //
    return lfDateIsValid;
  }
  //
  public cpifMatchString(psMatchName: string, psMatchValue: string) {
    function lfValidate(psValue: string): boolean | string {
      if (psMatchValue !== psValue) {
        return `${psMatchName} mismatch!`;
      }
      return true;
    }
    //
    return lfValidate;
  }
}
//#end#
